@if (displayedProduct(); as productData) {
  <app-product-panel-atom
    [product]="productData"
    [additions]="additions()"
    [isDisableButton]="!isButtonValid"
    [additionsByGroup]="additionsByGroup()"
    [shopOpensAt]="shopOpensAt"
    [compoundItems]="displayedCompoundItems()"
    [allowAddToCart]="allowAddToCart()"
    [index]="$any(index$ | async)"
    [headingColor]="headingColor() ?? defaultHeadingColor"
    [descriptionColor]="descriptionColor() ?? defaultDescriptionColor"
    [inactiveStateColor]="inactiveStateColor() ?? defaultInactiveStateColor"
    [priceColor]="priceColor() ?? defaultPriceColor"
    [displayPrice]="displayPrice()"
    [maxProduct]="maxProduct()"
    [backgroundColor]="backgroundColor()"
    [textColor]="textColor()"
    [buttonBackgroundColor]="buttonBackgroundColor()"
    [buttonTextColor]="buttonTextColor()"
    [tagColors]="$any(tagColors$ | async)"
    [hideAdditionGroupDetails]="hideAdditionGroupDetails()"
    (addProduct)="addToCart()"
    (closePanel)="close()"
    (toggleAddition)="onSelectAddition($event)"
    (changeQuantity)="onChangeNbProduct($event)"
    (changeAdditionQuantity)="onChangeNbAddition($event)"
    (openCompound)="openCompound($event)"
  ></app-product-panel-atom>
}
